<script setup>
import AppPastPayments from "@/components/Admin/Tabs/AppPastPayments";
import {ref, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import {useContractInfo} from "@/use/contract-info";
//----------------------------------------------------------------------
const store = useStore()
const loading = ref(false)

onMounted( ()=>{
  store.commit('menuModule/initMenu')
  const ifDataExist = !!contract.value
  // если данные есть в сторе, грузить не будем
  init(ifDataExist)
})

const init = async (ifDataExist) => {
  // если данные есть в сторе, грузить не будем
  if (!ifDataExist) {
    await useContractInfo(token.value, user.value.type, user.value.id)
  }
  loading.value = true
}

//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})
const contract = computed( () => {return store.getters['contractModule/contract']})
</script>

<template>
  <main class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col d-flex justify-content-between">
            <h3>Мои платежи</h3>
          </div>
          <router-link :to="{name: 'payments-schedule'}" class="black-link">
            <div class="d-flex">
              <v-icon class="action-icon--calendar" icon="mdi:chart-bar"></v-icon>
              <p class="pt-1 pl-2 pr-3">График платежей</p>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div v-if="loading" class="row">
          <div class="col-12" v-if="user">

            <div v-if="contract[0].delay == 0" class="alert-success p-2 mb-4 rounded d-flex align-items-center">
              <v-icon
                  icon="mdi:check-circle-outline"
                  class="icon--light-big mr-3"
              ></v-icon>
              <h5 class="pt-2">У Вас нет просроченных платежей</h5>
            </div>
            <div v-else class="alert-danger p-2 mb-4 rounded d-flex align-items-center">
              <v-icon
                  icon="mdi:bell-plus-outline"
                  class="icon--light-big mr-3"
              ></v-icon>
              <div>У Вас имеется просроченный платеж</div>
            </div>

            <app-past-payments></app-past-payments>
          </div>
        </div>
        <div v-else class="d-flex justify-content-center">
          <div class="spinner-border text-primary m-4" role="status"></div>
        </div>
      </div>
    </section>
  </main>
</template>
<style scoped>
.alert-success{background-color: #80b5d3 !important;}
.nav-link{cursor:pointer}
</style>